<template>
  <full-container>
    <div slot="header" class="toolbar">
      <el-form inline>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" size="small" clearable placeholder="订单号/客户名称">
            <template slot="append">
              <el-button icon="el-icon-search" @click="onSearch()" />
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-pagination layout="prev, next" :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
    </div>
    <!--表格-->
    <ul>
      <template v-for="(item, index) in datalist.Items">
        <li :key="index">
          <div class="text-sm text-info">
            <label>订单号：{{ item.Order.Code }}</label>
            <label style="margin-left: 20px">下单时间：{{ $utils.common.parseTime(item.Order.CreateTime, '{y}-{m}-{d} {h}:{i}') }}</label>
          </div>
          <p class="grid">
            <label>
              <b>
                {{ $utils.meta.format('branch', item.Goods.Stock) }}
                {{ item.Goods.Code }}
              </b>
              {{ item.Goods.Name }}
            </label>
            <template>
              <label>{{ item.Parcels }}/{{ item.Amount }}{{ item.Goods.Unit }}</label>
              <el-input-number
                v-model="item.Value"
                :min="0"
                :max="item.Amount - item.Parcels"
                size="mini"
                @change="
                  onChange({
                    OrderId: item.Order.Id,
                    GoodsId: item.Goods.Id,
                    ParentId: item.Goods.Parent,
                    Stock: item.Goods.Stock,
                    Code: item.Goods.Code,
                    Name: item.Goods.Name,
                    Unit: item.Goods.Unit,
                    Amount: item.Value,
                  })
                "
              />
            </template>
          </p>
        </li>
      </template>
    </ul>
    <!--页尾-->
    <div slot="footer" class="toolbar">
      <label class="text-info">*只读取数量>0商品</label>
      <el-button type="primary" @click="onSubmit()">确定选择</el-button>
    </div>
  </full-container>
</template>


<script>
export default {
  props: {
    customer: { type: String },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      datalist: {},
      selected: [],
      queryParams: {
        index: 1,
        size: 20,
        state: false,
        customer: this.customer
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.mall.order.item.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    onChange (item) {
      console.log(item)
      let index = this.selected.findIndex(x => x.OrderId == item.OrderId
        && x.GoodsId == item.GoodsId
        && x.ParentId == item.ParentId)
      if (index != -1) {
        this.selected.splice(index, 1)
      }
      if (item.Amount > 0) {
        this.selected.push(item)
      }
    },

    //确认返回
    onSubmit () {
      typeof this.callback == "function" && this.callback(this.selected.filter(x => x.Amount > 0))
      this.$layer.close(this.layerid)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  border-top: 1px solid #ebeef5;
  li {
    padding: 10px 0;
    list-style: none;
    border-bottom: 1px solid #ebeef5;
    line-height: 2;
    p.grid {
      margin-top: 10px;
      display: grid;
      grid-template-columns: 4fr 1fr auto;
      align-items: center;
    }
  }
}
</style>
